
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 5.25a.75.75 0 01.75.75v1.25h10.5V6a.75.75 0 011.5 0v1.25H21a.75.75 0 01.75.75v6a.75.75 0 01-.75.75h-2.25V20a.75.75 0 01-1.5 0v-5.25H6.75V20a.75.75 0 01-1.5 0v-5.25H3a.75.75 0 01-.75-.75V8A.75.75 0 013 7.25h2.25V6A.75.75 0 016 5.25zm12 3.5H3.75v4.5h16.5v-4.5H18zM7.25 17a.75.75 0 01.75-.75h8a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75zm6.28-6.47a.75.75 0 10-1.06-1.06l-2 2a.75.75 0 101.06 1.06l2-2zm-5-1.06a.75.75 0 010 1.06l-2 2a.75.75 0 01-1.06-1.06l2-2a.75.75 0 011.06 0zm10 1.06a.75.75 0 10-1.06-1.06l-2 2a.75.75 0 101.06 1.06l2-2z"}})])
          )
        }
      }
    